import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({ spacing }: Theme) => createStyles({
    item: {
        paddingTop: spacing.unit,
        paddingBottom: spacing.unit
    },
    title: {
        textTransform: "uppercase",
        marginBottom: spacing.unit
    }
});


// WEBPACK FOOTER //
// ./src/components/Conditions/Conditions.style.tsx